import React, { FC, PropsWithChildren } from 'react'

export const ContentContainer: FC<PropsWithChildren> = ({ children }) => {
  return <div className="container max-w-3xl">{children}</div>
}
